import colors from '@theme/colors';
import styled from 'styled-components';

const SuccessMessage = styled.div`
  color: ${colors.SUCCESS};
  padding-top: 20px;
  padding-left: 10px;
`;

export default SuccessMessage;



// WEBPACK FOOTER //
// ./components/atoms/SuccessMessage.js